import { createSlice } from "@reduxjs/toolkit";

const typeSlice = createSlice({
  name: "types",
  initialState: {
    types: [],
  },
  reducers: {
    setActiveTypes: (state, action) => {
      const types =
        action?.payload || [].sort((a, b) => a.priority - b.priority);
      state.types = types;
    },
    storeTypes: (state, action) => {
      const { path, data } = action.payload;
      state[path] = data;
      state.types = data || [];
    },
    clearTypes() {
      return {};
    },
  },
});

export const { setActiveTypes, storeTypes, clearTypes } = typeSlice.actions;
export default typeSlice.reducer;
